module.exports = __webpack_public_path__ + "static/media/Healthcare_Hero_04.69084a27.jpg";